import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/retry';
import { Tools } from '../tools';
export var MethodType;
(function (MethodType) {
    MethodType[MethodType["GET"] = 0] = "GET";
    MethodType[MethodType["POST"] = 1] = "POST";
    MethodType[MethodType["PUT"] = 2] = "PUT";
    MethodType[MethodType["DELETE"] = 3] = "DELETE";
})(MethodType || (MethodType = {}));
/**
 * Service that handles the requests to the API:
 */
var BackendService = (function () {
    /**
     * Constructor
     * @param {HttpClient} http HttpClient
     */
    function BackendService(http) {
        this.http = http;
    }
    BackendService.prototype.serverRequest = function (method, serviceUrl, body, retries) {
        if (body === void 0) { body = {}; }
        if (retries === void 0) { retries = 0; }
        var request;
        switch (method) {
            case MethodType.GET:
                request = this.http
                    .get(serviceUrl, {
                    params: body,
                })
                    .retry(+retries);
                break;
            case MethodType.POST:
                request = this.http.post(serviceUrl, body).retry(+retries);
                break;
            case MethodType.PUT:
                request = this.http.put(serviceUrl, body).retry(+retries);
                break;
            case MethodType.DELETE:
                request = this.http
                    .delete(serviceUrl, {
                    params: body,
                })
                    .retry(+retries);
                break;
            default:
                break;
        }
        return new Promise(function (resolve, reject) {
            request.subscribe(function (response) {
                resolve(response);
            }, function (err) {
                reject(Tools.checkError(err));
            });
        });
    };
    /**
     * Get method
     * @param serviceUrl URL
     * @param {object} params Params
     * @param {number} retries Number of retries
     * @returns {Promise<T>} Response as promise
     */
    BackendService.prototype.get = function (serviceUrl, params, retries) {
        if (params === void 0) { params = {}; }
        if (retries === void 0) { retries = 0; }
        // The route interceptor will replace the '$' by the backend url
        return this.serverRequest(MethodType.GET, '$' + serviceUrl, params, retries);
    };
    /**
     * Post method
     * @param serviceUrl URL
     * @param {object} body Body with params
     * @param {number} retries Number of retries
     * @returns {Promise<T>} Response as promise
     */
    BackendService.prototype.post = function (serviceUrl, body, retries) {
        if (body === void 0) { body = {}; }
        if (retries === void 0) { retries = 0; }
        // The route interceptor will replace the '$' by the backend url
        return this.serverRequest(MethodType.POST, '$' + serviceUrl, body, retries);
    };
    /**
     * Put method
     * @param serviceUrl URL
     * @param {object} body Body with params
     * @param {number} retries Number of retries
     * @returns {Promise<T>} Response as promise
     */
    BackendService.prototype.put = function (serviceUrl, body, retries) {
        if (body === void 0) { body = {}; }
        if (retries === void 0) { retries = 0; }
        // The route interceptor will replace the '$' by the backend url
        return this.serverRequest(MethodType.PUT, '$' + serviceUrl, body, retries);
    };
    /**
     * Delete method
     * @param serviceUrl URL
     * @param {object} params Params
     * @param {number} retries Number of retries
     * @returns {Promise<T>} Response as promise
     */
    BackendService.prototype.delete_ = function (serviceUrl, params, retries) {
        if (params === void 0) { params = {}; }
        if (retries === void 0) { retries = 0; }
        // The route interceptor will replace the '$' by the backend url
        return this.serverRequest(MethodType.DELETE, '$' + serviceUrl, params, retries);
    };
    return BackendService;
}());
export { BackendService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/backend.service.ts.pre-build-optimizer.js